import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEqual } from "@utils/lodash";
import Utils from "@utils";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import ReportsTable from "./components/ReportsTable";
import { detailedJobReportsColumn } from "./utils/columnsDefinition";

class DetailedInvoiceReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			jobData: this.processJobData(props.data.JobDetailedPaymentSummaries || []),
			agencyAllowedToUseExcludeOfficerRate: props.data.AgencyAllowedToExcludeOfficerRate,
		};

		const {
			flags: { workersCompensationFee },
		} = props;
		this.hasWorkersCompensationFee = !!workersCompensationFee;
	}

	componentDidUpdate({ data: prevData }) {
		const { data } = this.props;
		if (!isEqual(prevData, data)) {
			// This ESLint rule could possibly be disabled permanently. Further discussions will be necessary, but disabling in this file for right now
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ jobData: this.processJobData(data.JobDetailedPaymentSummaries) });
			this.setState({
				agencyAllowedToUseExcludeOfficerRate: data.AgencyAllowedToExcludeOfficerRate,
			});
		}
	}

	processJobData = rawJobData => {
		if (!(rawJobData instanceof Array)) return [];
		const jobSummary = [...rawJobData];
		if (jobSummary.length) {
			jobSummary.map(item => {
				const statusObj = Utils.getNewJobStatus(item);
				return { ...item, statusObj };
			});
		}
		return jobSummary;
	};

	render() {
		const { jobData, agencyAllowedToUseExcludeOfficerRate } = this.state;
		const {
			user,
			data: { reportType },
		} = this.props;
		return (
			<div className="panel reports-panel">
				<div className="panel-content">
					<ReportsTable
						hideTitle
						reportType={reportType}
						data={jobData}
						tableColumn={detailedJobReportsColumn(
							user,
							this.hasWorkersCompensationFee,
							agencyAllowedToUseExcludeOfficerRate,
						)}
					/>
				</div>
			</div>
		);
	}
}

DetailedInvoiceReport.propTypes = {
	data: PropTypes.array,
	user: PropTypes.object,
	flags: PropTypes.object.isRequired,
};

DetailedInvoiceReport.defaultProps = {
	data: [],
	user: {},
};

export default withLDConsumer()(DetailedInvoiceReport);
